export default import.meta.ROLLUP_FILE_URL_vw5IROG8juLTnfgQQmW5Og